import { createZodDto } from "nestjs-zod/dto";
import z from "zod";

const createCreditCreationSchema = z.object({
  quantity: z.number(),
  remain: z.number(),
  souscriptionId: z.string().optional().nullable(),
  userId: z.string(),
});

export class CreateCreditCreationDto extends createZodDto(createCreditCreationSchema) {}
